import { storage } from 'BASE/common/util/util.storage';

export function get(path) {
    return storage.local.get(storage.keys.API_PROXY);
}

export function set(proxy) {
    storage.local.set(storage.keys.API_PROXY, proxy);
}

export function urlCombine(path) {
    path = path? path: '';  //以防沒設定path變成null頁面顯示錯誤 (如: logo後台沒設定)

    let proxy = get();
    if(!proxy)
        return path;

    return proxy + path;
}

export function urlRedirect(path) {
    if (typeof CORDOVA_URL_REWRITE != 'undefined' && CORDOVA_URL_REWRITE) {
        let match = JSON.parse(CORDOVA_URL_REWRITE).find(r => path.match(r.pattern));
        if (match) {
            return match.rewrite.replace(/\$\{path\}/g, path);
        }
    }
    return urlCombine(path);
}